export const MODEL_RETRY_DELAYS_MS = [5_000, 10_000, 15_000, 30_000, 60_000] as const;

function delay(milliseconds: number) {
  return new Promise<void>((resolve) => globalThis.setTimeout(resolve, milliseconds));
}

export async function retryModelChunk<T>(task: () => Promise<T>, onRetry?: (attempt: number, delayMs: number, error: unknown) => void): Promise<T> {
  let lastError: unknown;
  for (let attempt = 0; attempt <= MODEL_RETRY_DELAYS_MS.length; attempt++) {
    try { return await task(); }
    catch (error) {
      lastError = error;
      const delayMs = MODEL_RETRY_DELAYS_MS[attempt];
      if (delayMs === undefined) break;
      onRetry?.(attempt + 1, delayMs, error);
      await delay(delayMs);
    }
  }
  throw lastError;
}
